// extracted by mini-css-extract-plugin
export var optionGrid = "_7f-7";
export var optionList = "_7f-6";
export var questionsBlock = "_7f-9";
export var spacer = "_7f-5";
export var stepCenteredContent = "_7f-3";
export var stepInner = "_7f-0";
export var stepInnerFullWidth = "_7f-1";
export var stepInnerLockScroll = "_7f-2";
export var stepTransitionFrame = "_7f-4";
export var welcomeBlock = "_7f-8";